import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import ThemeToggle from '../theme/ThemeToggle';
import SpaceBackground from './auth/SpaceBackground';
import './AuthLayout.css';

function AuthLayout({ leftContent, children }) {
  return (
    <div className="auth-layout">
      <SpaceBackground />

      <header className="auth-header">
        <Link to="/" className="auth-logo-link">
          <Logo size="small" />
        </Link>
        <ThemeToggle />
      </header>

      <div className="auth-columns">
        <aside className="auth-left">{leftContent}</aside>
        <section className="auth-right">{children}</section>
      </div>
    </div>
  );
}

export default AuthLayout;
